/** Arabic rail labels from the Design canvas artboard web/_rail (Trump canvas). Keyed by the English title the
 *  rail already uses; used only under the Design System preview flag when the language is Arabic. */
export const NAV_AR: Record<string, string> = {
  Protect: 'الحماية', Crypto: 'الكريبتو', Overview: 'نظرة عامة', Scanner: 'الماسح', 'Elite Pulse': 'إيليت بلس',
  Dashboard: 'اللوحة', 'Flow Tape': 'شريط التدفق', Watchlist: 'المتابعة', Flow: 'التدفق', 'Options Tape': 'شريط الخيارات',
  'Flow Heatmap': 'خريطة التدفق', 'Flow Matrix': 'مصفوفة التدفق', Volatility: 'التقلب', 'IV Tracking': 'تتبع التقلب الضمني',
  'Edge Journey': 'رحلة الأفضلية', 'Market Climate': 'مناخ السوق', 'IV Scanner': 'ماسح التقلب', 'Path Cloud': 'سحابة المسارات',
  'Structure Lab': 'مختبر الهيكل', 'Daily Edge List': 'قائمة الأفضلية اليومية', News: 'الأخبار', 'News Feed': 'الأخبار',
  'Event Outlook': 'آفاق الأحداث', 'Statement Tracker': 'متتبع التصريحات', GEX: 'GEX', 'GEX Workspace': 'مساحة GEX',
  'Vol/OI/SG': 'الحجم/OI/SG', 'Vertical SG/OI': 'SG/OI عمودي', 'Gamma Shift': 'تحول جاما', 'Net Drift': 'الانجراف الصافي',
  Charts: 'الرسوم', 'Options Charts': 'رسوم الخيارات', Tools: 'الأدوات', 'σ Calculator': 'حاسبة σ',
  'Posted Calls': 'الإشارات المنشورة', 'Trading Calls': 'إشارات التداول', 'Call Tracker': 'متابع الإشارات',
  'Call Generator': 'مولّد الإشارات', 'Legacy RTL': 'RTL القديم', 'Volume / Δ / Trades (one page)': 'الحجم / Δ / الصفقات',
  'Trades (reformed)': 'الصفقات',
};

export function navLabel(title: string, ar: boolean): string {
  return ar ? NAV_AR[title] ?? title : title;
}
